const vacation = `Dear Mika,
I hope you're having an amazing time in Italy! 
I wanted to let you know that your cat is doing great. 
I've been stopping by every day to make sure she has everything she needs. 
Your home is in good shape, too, so you don't need to worry about anything.
Italy sounds incredible, and I can't wait to hear all about your adventures when you get back. 
I bet the food there is absolutely amazing! 
Please bring a nice souvenier from Italy when you come back.
Also, I wanted to share some exciting news. 
I finally finished redecorating my living room, and it looks fantastic! 
I can't wait for you to come over and see it.
Take care and enjoy the rest of your vacation!
Best`;

export default vacation;